import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import db from "../../db/db";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import { Button, Typography } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import API from "../../utils/API";
import MText from "../../components/pos/MText";
import MSelect from "../../components/pos/MSelect";
import { AgentUtils } from "../../utils/AgentUtils";
import { PrintUtils } from "../../utils/PrintUtils";
import PConfirm from "../../components/pos/PConfirm";
import PSelect from "../../components/pos/PSelect";
import ServiceUpdate from "./ServiceUpdate";
import PFileViewer from "../../components/pos/PFileViewer";
import PDatePicker from "../../components/pos/PDatePicker";
import { StringUtils } from "../../utils/StringUtils";
import PText from "../../components/pos/PText";
import { SaleUtils } from "../../utils/SaleUtils";

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          padding: 5,
        },
        head: {
          padding: 2,
          paddingLeft: 10,
          paddingRight: 10,
        },
        paddingCheckbox: {
          width: 0,
        },
      },
    },

    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          paddingLeft: 5,
        },
      },
    },

    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: 7,
        },
        adornedEnd: {
          paddingRight: 0,
        },
      },
    },
  },
});

export default function MSaleHistory(props) {
  const { t } = useTranslation();
  const translate = t;
  const [anchorEl, setAnchorEl] = useState(null);
  const [invoiceSearchText, setInvoiceSearchText] = useState("");
  const [customerNameSearch, setCustomerNameSearch] = useState("");

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const [selectedTerminal, setSelectedTerminal] = useState(null);

  const [serviceBean, setServiceBean] = useState(null);
  const [showServiceUpdateWindow, setShowServiceUpdateWindow] = useState(false);
  const [openFileViewWindow, setOpenFileViewWindow] = useState(false);
  const [previewFileList, setPreviewFileList] = useState([]);

  const [saleHistoryData, setSaleHistoryData] = useState([]);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.floor((AgentUtils.getWindowDimensionsExAppBars().h - 115) / 51)
  );
  const [saleId, setSaleId] = useState(null);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isFisrstCall, setIsFisrstCall] = useState(true);
  const [searchFilter, setSearchFilter] = useState("");
  const [reportType, setReportType] = useState();

  const [searchFilterOptions, setSearchFilterOptions] = useState([
    { id: 1, name: "Active Sales" },
    { id: 3, name: "Customer" },
    { id: 5, name: "Invoice Number" },
    { id: 6, name: "Terminal" },
  ]);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  let jasperFlag = null;

  useEffect(() => {
    const opt = { ...option };
    opt.searchText = JSON.stringify({
      saleSession: props.saleSession ? props.saleSession.id : null,
    });
    setOption(opt);
    setSearchFilter({ id: 1, name: "Active Sales" });
    internalhandleHistorySearch1(
      null,
      null,
      null,
      null,
      null,
      0,
      props.saleSession.id
    );

    var beforeDate = new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000);
    setStartDate(beforeDate);
    setEndDate(new Date());

    initHistory();
    // setSelectedTerminal({
    //   name: props.terminalBean.name,
    //   id: props.terminalBean.id,
    // });
  }, []);

  useEffect(() => {
    console.log("props.userOptions", props.userOptions);
  }, [props.userOptions]);

  async function initHistory() {
    await initilizePrintType(getPrintFormat());
    // await loadData();
  }

  function getStatusFilter() {
    if (props.saleType == "SALE_ORDER") {
      return selectedStatus ? selectedStatus.id : null;
    }
    if (props.saleType == "SERVICE") {
      return selectedStatus ? selectedStatus.id : null;
    }
    return "FINAL";
  }

  async function onSearch() {
    internalhandleHistorySearch1(
      searchFilter.id == 5 ? invoiceSearchText : null,
      searchFilter.id == 3 ? customerNameSearch : null,
      getStatusFilter(),
      null,
      searchFilter.id == 6 ? selectedTerminal.id : null,
      0,
      searchFilter.id == 1 ? props.saleSession.id : null
    );
  }

  function getPrintFormat() {
    if (props.saleType === "SALE") {
      return "SALE_RECEIPT_PRINT_FORMAT";
    }
    if (props.saleType === "SALE_RETURN") {
      return "SALE_RETURN_RECEIPT_PRINT_FORMAT";
    }
    if (props.saleType === "SERVICE") {
      return "SERVICE_RECEIPT_PRINT_FORMAT";
    }
    if (props.saleType === "SALE_ORDER") {
      return "SALE_ORDER_PRINT_FORMAT";
    }
    return "";
  }

  useEffect(() => {
    // if (!isFisrstCall) {
    //   handleHistorySearch();
    // }

    const opt = { ...option };
    opt.searchText = JSON.stringify({
      saleSession: null,
    });

    opt.count = 0;
    setOption(opt);
    setSaleHistoryData([]);

    if (searchFilter.id == 1) {
      const opt = { ...option };
      opt.searchText = JSON.stringify({
        saleSession: props.saleSession ? props.saleSession.id : null,
      });
      setOption(opt);
    }
  }, [searchFilter]);

  function Reset() {
    if (searchFilter.id == 1) {
      setCustomerNameSearch("");
      setInvoiceSearchText("");
      setSelectedTerminal(props.terminalOptions[0]);
    }
    if (searchFilter.id == 2) {
      setCustomerNameSearch("");
      setSelectedTerminal(props.terminalOptions[0]);
      setInvoiceSearchText("");
    }

    if (searchFilter.id == 3) {
      setInvoiceSearchText("");
      setSelectedTerminal(props.terminalOptions[0]);
    }
    if (searchFilter.id == 4) {
      setCustomerNameSearch("");
      setInvoiceSearchText("");
    }
    if (searchFilter.id == 5) {
      setCustomerNameSearch("");
      setSelectedTerminal(null);
    }
    if (searchFilter.id == 6) {
      setCustomerNameSearch("");
      setInvoiceSearchText("");
    }
  }

  const open = Boolean(anchorEl);

  function handleClick(event, value) {
    setSaleId(value);
    setAnchorEl(event.currentTarget);
  }

  function onRefreshList() {
    //TODO
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  function internalhandleHistorySearch1(
    invoice,
    customerName,
    status,
    user,
    terminal,
    page,
    saleSessionId
  ) {
    let sort = '[{id:"date",sortOrder:"DESC"}]';

    let filter = { and: [], or: [] };

    let search = [];

    if (startDate) {
      let d = new Date(
        startDate.$d ? startDate.$d.getTime() : startDate.getTime()
      );
      d.setHours(0, 0, 0, 0);

      filter.and.push({
        op: "gt",
        type: "Date",
        key: "date",
        value: d,
      });
    }
    if (endDate) {
      let d = new Date(endDate.$d ? endDate.$d.getTime() : endDate.getTime());
      d.setHours(23, 59, 59, 999);
      filter.and.push({
        op: "lte",
        type: "Date",
        key: "date",
        value: d,
      });
    }

    if (saleSessionId) {
      filter.and.push({
        op: "eq",
        key: "saleSessionId",
        value: saleSessionId,
      });
    }

    if (invoice) {
      filter.and.push({
        op: "eq",
        key: "invoiceNo",
        value: invoice,
      });
    }

    if (customerName) {
      filter.and.push({
        op: "containsi",
        key: "customerName",
        value: customerName,
      });
    }

    if (props.saleType === "SERVICE") {
      if (status) {
        filter.and.push({
          op: "eq",
          key: "serviceStatus",
          value: status,
        });
      } else {
        filter.and.push({
          op: "eq",
          key: "serviceStatus",
          value: "CLOSED",
        });
      }
      if (user) {
        filter.and.push({
          op: "eq",
          key: "assigned",
          value: user,
        });
      }
    }
    if (props.saleType === "SALE_ORDER") {
      if (status) {
        filter.and.push({
          op: "eq",
          key: "saleOrderStatus",
          value: status,
        });
      } else {
        filter.and.push({
          op: "eq",
          key: "saleOrderStatus",
          value: "CLOSED",
        });
      }
    }

    if (terminal) {
      filter.and.push({
        op: "eq",
        key: "terminalId",
        value: terminal,
      });
    }

    loadByRest(page, rowLimitPerPage, sort, JSON.stringify(filter));
  }

  async function loadByRest(curPage, pageSize, sort, filter) {
    props.showProgress(translate("Searching .. "));
    try {
      const { data } = await API.get(
        "/e_search/sales?range=" +
          encodeURIComponent(
            "[" + curPage * (pageSize - 1) + "," + pageSize + "]"
          ) +
          "&filter=" +
          encodeURIComponent(filter) +
          "&sort=" +
          encodeURIComponent(sort) +
          "&searchType=" +
          encodeURIComponent(props.saleType)
      );
      const opt = { ...option };
      opt.searchText = filter;
      opt.count = data.metadata.length > 0 ? data.metadata[0].total : 0;
      setOption(opt);

      let histData = [];
      console.log("terminalOptions", props.terminalOptions);
      for (let d of data.data) {
        console.log("terminalOptions", d);
        d["menuOptions"] = await getMenuOptions(d);
        let term = SaleUtils.getOption(props.terminalOptions, d.terminalId);
        d["terminalName"] = term ? term.name : "";
        histData.push(d);
      }

      setSaleHistoryData(histData);
      setIsFisrstCall(false);
    } catch (err) {
      console.error("ERROR", err);
      props.showMessage(
        "error",
        translate("Not able to retrive sale history from server")
      );
    } finally {
      props.hideProgress();
    }
  }

  async function initilizePrintType(printFormat) {
    let dbData = await db.config.where("name").equals(printFormat).toArray();
    let configText = "";
    if (dbData[0]) configText = dbData[0].configTxt;

    if (configText.startsWith("{")) {
      let json = JSON.parse(configText);
      if (json.engine === "jasper") {
        setReportType("JASPER");
        jasperFlag = true;
      }
    } else {
      setReportType("ESCPOS");
      jasperFlag = false;
    }
  }

  async function download(data, option) {
    props.showProgress(translate("Generating "));
    try {
      PrintUtils.augmentSaleDetailsForPrint(
        data,
        props.context.store.currencyDecimal,
        props.saleType
      );
      let pdf = await PrintUtils.generateReceiptAsPdf(
        getPrintFormat(),
        data,
        option.index
      );
      const downloadLink = document.createElement("a");
      const fileName = data.invoiceNo + ".pdf";
      downloadLink.href = pdf.data;
      downloadLink.download = fileName;
      downloadLink.click();
    } catch (err) {}
    props.hideProgress();
  }

  async function viewFile(data, option) {
    props.showProgress(translate("Generating "));
    try {
      PrintUtils.augmentSaleDetailsForPrint(
        data,
        props.context.store.currencyDecimal,
        props.saleType
      );
      console.log("option.index", option.index);
      let pdf = await PrintUtils.generateReceiptAsPdf(
        getPrintFormat(),
        data,
        option.index
      );

      let fileList = [];

      let item = {
        selected: true,
        previewObj: pdf.data,
        fileType: "DOCUMENT",
      };

      console.log(item);

      fileList.push(item);
      setPreviewFileList(fileList);
      setOpenFileViewWindow(true);
    } catch (err) {}
    props.hideProgress();
  }

  async function print(data, option) {
    props.showProgress(translate("Printing "));
    try {
      PrintUtils.augmentSaleDetailsForPrint(
        data,
        props.context.store.currencyDecimal,
        props.saleType
      );
      await PrintUtils.printReceipt(
        props.terminalBean,
        getPrintFormat(),
        data,
        props.setAlert,
        true,
        translate,
        true,
        false,
        null,
        props.pdfViewer,
        option.index
      );
    } catch (err) {}
    props.hideProgress();
  }

  async function openSale(data) {
    props.handleSelectSale(data, "sale", false, true);
  }

  async function openSaleWithNewDate(data) {
    props.handleSelectSale(data, "sale", true);
  }
  async function openService(data) {
    props.handleSelectService(data, "service");
  }
  async function updateService(data) {
    setServiceBean(data);
    setShowServiceUpdateWindow(true);
  }

  async function cancelSaleOrder(data) {
    setConfirmOpen(true);
    setConfirmContext({
      title: "Are You Sure",
      message:
        "Are you sure to cancel " +
        (props.context.storeAdmin.saleOrderName
          ? props.context.storeAdmin.saleOrderName
          : "Sale Order") +
        " with Invocie No :" +
        data.invoiceNo +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      saleId: data.id,
      invoiceNo: data.invoiceNo,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let { data } = await API.post(
          "/api/v1/sale/saleorder/" + context.saleId + "/cancel"
        );
        props.showMessage(
          "warning",
          (props.context.storeAdmin.saleOrderName
            ? props.context.storeAdmin.saleOrderName
            : "Sale Order") +
            " " +
            context.invoiceNo +
            " got Cancelled"
        );
        let payload = data;

        PrintUtils.augmentSaleDetailsForPrint(
          payload,
          props.context.store.currencyDecimal,
          props.saleType
        );

        await PrintUtils.printReceipt(
          props.terminalBean,
          getPrintFormat(),
          payload,
          props.setAlert,
          true,
          translate,
          true,
          false,
          null,
          props.pdfViewer
        );
      } catch (err) {
        console.log(err);
        props.showMessage(
          "success",
          "Not able to Cancel " +
            (props.context.storeAdmin.saleOrderName
              ? props.context.storeAdmin.saleOrderName
              : "Sale Order") +
            " " +
            context.invoiceNo
        );
      }
    }
  }

  function createInvoice(data) {
    props.createInvoiceFromSaleOrder(data);
  }

  function createInvoiceFromService(data) {
    props.createInvoiceFromService(data);
  }

  async function getMenuOptions(d) {
    let m = [];
    let i = 0;
    let j = 0;
    let k = 0;
    if (props.eventSource == "SALE_HISTORY") {
      if (
        props.storeAdminSetting.allowEditingSale &&
        props.context.privileges.sale_edit
      ) {
        m.push({
          key: "Open",
          value: translate("Edit Sale"),
          callback: openSale,
        });
      }

      for (let d of props.paymentSettings.printButtons) {
        let menuLabel = d.menuLabel ? d.menuLabel : "";
        m.push({
          key: "download",
          value: translate(menuLabel + " Download"),
          callback: download,
          index: k++,
        });
        m.push({
          key: "print",
          value: translate(menuLabel + " Print"),
          callback: print,
          index: i++,
        });
        m.push({
          key: "view",
          value: translate(menuLabel + " view"),
          callback: viewFile,
          index: j++,
        });
      }
    }
    if (props.eventSource == "SALE_IN_R_SALE") {
      m.push({
        key: "view",
        value: translate("View"),
        callback: viewFile,
      });
      m.push({
        key: "download",
        value: translate("Download"),
        callback: download,
      });
      m.push({
        key: "print",
        value: translate("print"),
        callback: print,
      });
    }
    if (props.eventSource == "SALE_RETURN_HISTORY") {
      // m.push({
      //   key: "view",
      //   value: translate("View"),
      //   callback: viewFile,
      // });
      // m.push({
      //   key: "download",
      //   value: translate("Download"),
      //   callback: download,
      // });
      // m.push({
      //   key: "print",
      //   value: translate("print"),
      //   callback: print,
      // });
      for (let d of props.paymentSettings.printButtons) {
        let menuLabel = d.menuLabel ? d.menuLabel : "";
        m.push({
          key: "download",
          value: translate(menuLabel + " Download"),
          callback: download,
          index: k++,
        });
        m.push({
          key: "print",
          value: translate(menuLabel + " Print"),
          callback: print,
          index: i++,
        });
        m.push({
          key: "view",
          value: translate(menuLabel + " view"),
          callback: viewFile,
          index: j++,
        });
      }
    }

    if (props.eventSource == "SALE_ORDER_HISTORY") {
      m.push({
        key: "view",
        value: translate("View"),
        callback: viewFile,
      });
      m.push({
        key: "download",
        value: translate("Download"),
        callback: download,
      });
      m.push({
        key: "print",
        value: translate("print"),
        callback: print,
      });
      if (d.saleOrderStatus != "CANCELLED") {
        m.push({
          key: "cancel_sale_order",
          value: translate(
            "Cancel " +
              (props.context.storeAdmin.saleOrderName
                ? props.context.storeAdmin.saleOrderName
                : "Sale Order")
          ),
          callback: cancelSaleOrder,
        });
      }
    }

    if (props.eventSource == "SALE_IN_RETURN") {
      m.push({
        key: "Open",
        value: translate("Return"),
        callback: openSaleWithNewDate,
      });
      m.push({
        key: "view",
        value: translate("View"),
        callback: viewFile,
      });
      m.push({
        key: "download",
        value: translate("Download"),
        callback: download,
      });
      m.push({
        key: "print",
        value: translate("print"),
        callback: print,
      });
    }

    if (props.eventSource == "SALE_ORDER_IN_SALE") {
      if (d.saleOrderStatus != "CLOSED") {
        m.push({
          key: "create_invocie",
          value: translate("Create Invoice"),
          callback: createInvoice,
        });
      }
      m.push({
        key: "view",
        value: translate("View"),
        callback: viewFile,
      });
      m.push({
        key: "download",
        value: translate("Download"),
        callback: download,
      });
      m.push({
        key: "print",
        value: translate("print"),
        callback: print,
      });
      if (d.saleOrderStatus != "CANCELLED") {
        m.push({
          key: "cancel_sale_order",
          value: translate(
            "Cancel " +
              (props.context.storeAdmin.saleOrderName
                ? props.context.storeAdmin.saleOrderName
                : "Sale Order")
          ),
          callback: cancelSaleOrder,
        });
      }
    }

    if (props.eventSource == "SERVICE_IN_SALE") {
      if (d.serviceStatus != "CLOSED") {
        m.push({
          key: "create_invocie",
          value: translate("Create Invoice"),
          callback: createInvoiceFromService,
        });
      }
      m.push({
        key: "update",
        value: translate("Update"),
        callback: updateService,
      });
      m.push({
        key: "view",
        value: translate("View"),
        callback: viewFile,
      });
      m.push({
        key: "download",
        value: translate("Download"),
        callback: download,
      });
      m.push({
        key: "print",
        value: translate("print"),
        callback: print,
      });
    }

    if (props.eventSource == "SERIVCE_HISTORY") {
      if (d.serviceStatus != "CLOSED") {
        m.push({
          key: "Open",
          value: translate("Open"),
          callback: openService,
        });
      }

      m.push({
        key: "update",
        value: translate("Update"),
        callback: updateService,
      });

      m.push({
        key: "view",
        value: translate("View"),
        callback: viewFile,
      });

      m.push({
        key: "download",
        value: translate("Download"),
        callback: download,
      });
      m.push({
        key: "print",
        value: translate("print"),
        callback: print,
      });
    }

    return m;
  }
  const options = {
    textLabels: {
      body: {
        noMatch: "No sale data found",
      },
    },
    filterType: "checkbox",
    filter: false,
    search: false,
    serverSide: true,
    print: false,
    download: false,
    viewColumns: false,
    title: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    pagination: true,
    responsive: "standard",
    tableBodyHeight:
      (AgentUtils.getWindowDimensionsExAppBars().h - 150).toString() + "px",
    rowsPerPage: Math.floor(
      (AgentUtils.getWindowDimensionsExAppBars().h - 150) / 51
    ),
    rowsPerPageOptions: [
      Math.floor((AgentUtils.getWindowDimensionsExAppBars().h - 150) / 56),
      15,
      50,
      100,
    ],
    textLabels: {
      pagination: {
        rowsPerPage: "",
      },
    },
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
      }
    },
  };

  async function onTableChange(tableState) {
    console.log("State Change", tableState.searchText);

    loadByRest(tableState.page, rowLimitPerPage, [], tableState.searchText);
  }

  const [option, setOption] = useState(options);

  function formatDate(date) {
    let formatted =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getDate() +
      " " +
      date.getHours() +
      ":" +
      date.getMinutes();
    return formatted;
  }

  function onMenuItemClicked(option) {
    setAnchorEl(null);
    fetchSale(saleId, option);
  }

  async function fetchSale(id, option) {
    console.log("id", id);
    console.log("id option", option);
    try {
      let { data } = await API.get("/api/v1/" + getAPI() + id);
      option.callback(data, option);
    } catch (err) {
      console.error("ERROR", err);
      props.showMessage(
        "error",
        translate("Not able to retrive sale data from server")
      );
    }
  }

  function getAPI() {
    if (props.saleType === "SALE") {
      return "sale/";
    }
    if (props.saleType === "SALE_RETURN") {
      return "sale/return/";
    }
    if (props.saleType === "SALE_ORDER") {
      return "sale/saleorder/";
    }
    if (props.saleType === "SERVICE") {
      return "sale/service/";
    }
  }

  function getInvoiceLabel() {
    if (props.saleType === "SALE") {
      return "Invoice Number";
    }
    if (props.saleType === "SALE_RETURN") {
      return "Return Invoice Number";
    }
    if (props.saleType === "SALE_ORDER") {
      return "Order Number";
    }
    if (props.saleType === "SERVICE") {
      return "SR Number";
    }
  }

  function getDesktopColumns() {
    let desktopColumns = [];
    desktopColumns.push(
      // {
      //   name: "date",
      //   label: translate("Date"),
      //   display: "true",
      //   options: {
      //     filter: false,
      //     sort: false,
      //   },
      // },
      {
        name: "date",
        label: translate("Date"),
        display: "true",
        options: {
          filter: false,
          sort: false,
          // customHeadLabelRender: (value, tableMeta, updateValue) => {
          //   return (
          //     <div style={{ marginTop: 7 }}>
          //       <PDatePicker
          //         value={sreachDate}
          //         type="date"
          //         onChange={(e) => setSreachDate(e.$d.toISOString())}
          //       ></PDatePicker>
          //     </div>
          //   );
          // },
          customBodyRender: (value, tableMeta, updateValue) => {
            return <div>{StringUtils.formatDate(new Date(value), 1)}</div>;
          },
        },
      },
      {
        name: "Sale",
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => {
            return (
              // <div style={{ marginTop: 7 }}>
              //   <MText
              //     label={getInvoiceLabel()}
              //     value={invoiceSearchText}
              //     onChange={(e) => {
              //       setInvoiceSearchText(e.target.value);
              //     }}
              //     style={{ width: "150px" }}
              //   ></MText>
              // </div>
              <div style={{ marginTop: 7 }}>{getInvoiceLabel()}</div>
            );
          },
          display: "true",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>{tableMeta.tableData[tableMeta.rowIndex].invoiceNo}</div>
            );
          },
        },
      },
      {
        name: "Sale",
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => {
            return (
              <div style={{ marginTop: 7 }}>
                {/* <MText
                  label={"Customer"}
                  value={customerNameSearch}
                  onChange={(e) => {
                    setCustomerNameSearch(e.target.value);
                  }}
                  style={{ width: "150px" }}
                ></MText> */}
                Customer
              </div>
            );
          },
          display: "true",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>{tableMeta.tableData[tableMeta.rowIndex].customerName}</div>
            );
          },
        },
      }
    );

    if (props.saleType === "SALE_ORDER") {
      desktopColumns.push({
        name: "Sale",
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => {
            return <div>Status</div>;
          },
          display: "true",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                {tableMeta.tableData[tableMeta.rowIndex].saleOrderStatus}
              </div>
            );
          },
        },
      });
    }

    if (props.saleType === "SERVICE") {
      desktopColumns.push(
        {
          name: "Sale",
          options: {
            filter: false,
            sort: false,
            customHeadLabelRender: (value, tableMeta, updateValue) => {
              return <div style={{ marginTop: 7 }}>Assigned</div>;
            },
            display: "true",
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{tableMeta.tableData[tableMeta.rowIndex].assigned}</div>
              );
            },
          },
        },
        {
          name: "Sale",
          options: {
            filter: false,
            sort: false,
            customHeadLabelRender: (value, tableMeta, updateValue) => {
              return <div style={{ marginTop: 7 }}>Status</div>;
            },
            display: "true",
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  {tableMeta.tableData[tableMeta.rowIndex].serviceStatus}
                </div>
              );
            },
          },
        }
      );
    }

    desktopColumns.push(
      {
        name: "terminalName",
        label: translate("Terminal"),
        options: {
          filter: false,
          sort: false,
          customHeadLabelRender: (value, tableMeta, updateValue) => {
            return (
              <div style={{ marginTop: 7, width: "150px" }}>
                {/* <PSelect
                  label={"Terminal"}
                  style={{
                    width: "150px",
                  }}
                  options={props.terminalOptions}
                  value={selectedTerminal}
                  onChange={(event, newValue) => {
                    setSelectedTerminal(newValue);
                  }}
                ></PSelect> */}
                Terminal
              </div>
            );
          },
        },
      },
      {
        name: "totalAmount",
        label: translate("Amount"),
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: "action",
        label: translate("Actions"),
        options: {
          filter: false,
          sort: false,
          display: "true",
          setCellHeaderProps: () => ({ align: "right" }),
          setCellProps: () => ({ align: "right" }),
          customBodyRender: (value, tableMeta, updateValue) => (
            <div>
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={(event) => {
                  handleClick(
                    event,
                    tableMeta.tableData[tableMeta.rowIndex].id
                  );
                }}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: 235,
                    width: "20ch",
                  },
                }}
              >
                {tableMeta.tableData[tableMeta.rowIndex].menuOptions.map(
                  (option, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        onMenuItemClicked(option);
                      }}
                    >
                      {option.value}
                    </MenuItem>
                  )
                )}
              </Menu>
            </div>
          ),
        },
      }
    );
    return desktopColumns;
  }

  const mobileColumns = [
    {
      name: "Sale",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: "8px",
                    marginLeft: "3px",
                    marginRight: "3px",
                  }}
                >
                  <MText
                    label="Invoice Number"
                    value={invoiceSearchText}
                    onChange={(e) => {
                      setInvoiceSearchText(e.target.value);
                    }}
                  ></MText>
                </Grid>
              </Grid>
            </div>
          );
        },
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <table width="100%">
              <tbody>
                <tr>
                  <td>
                    <Grid container>
                      <Grid item xs={12}>
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                {
                                  tableMeta.tableData[tableMeta.rowIndex]
                                    .invoiceNo
                                }
                              </td>
                              <td>
                                {
                                  tableMeta.tableData[tableMeta.rowIndex]
                                    .customerName
                                }
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Grid>
                      <Grid item xs={12}>
                        <div style={{ fontSize: "0.75rem" }}>
                          Date:{" "}
                          <b>
                            {formatDate(
                              new Date(
                                tableMeta.tableData[tableMeta.rowIndex].date
                              )
                            )}
                          </b>{" "}
                          Amount:{" "}
                          <b>
                            {
                              tableMeta.tableData[tableMeta.rowIndex]
                                .totalAmount
                            }
                          </b>
                        </div>
                      </Grid>
                    </Grid>
                  </td>
                  <td align="right">
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={(event) => {
                        handleClick(
                          event,
                          tableMeta.tableData[tableMeta.rowIndex].id
                        );
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          maxHeight: 220,
                          width: "20ch",
                        },
                      }}
                    >
                      {tableMeta.tableData[tableMeta.rowIndex].menuOptions.map(
                        (option, index) => (
                          <MenuItem
                            key={index}
                            onClick={() => {
                              onMenuItemClicked(option);
                            }}
                          >
                            {option.value}
                          </MenuItem>
                        )
                      )}
                    </Menu>
                  </td>
                </tr>
              </tbody>
            </table>
          );
        },
      },
    },
  ];

  return (
    <div>
      <Grid
        container
        spacing={1}
        style={{ paddingLeft: "0.5%", paddingBottom: "0.5%" }}
      >
        <Grid item xs={2}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <PSelect
                    label="Search Type"
                    options={searchFilterOptions}
                    value={searchFilter}
                    // errorMessage={}
                    placeholder={translate("Select...")}
                    onChange={(event, newValue) => {
                      setSearchFilter(newValue);
                      Reset();
                    }}
                  ></PSelect>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>

        {searchFilter.id === 5
          ? true && (
              <Grid item xs={2}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <PText
                          type="number"
                          label={getInvoiceLabel()}
                          value={invoiceSearchText}
                          onChange={(e) => {
                            setInvoiceSearchText(e.target.value);
                          }}
                          InputLabelProps={{ shrink: true }}
                        ></PText>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )
          : false}

        {searchFilter.id === 3
          ? true && (
              <Grid item xs={2}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>
                        <PText
                          type="text"
                          label={"Customer"}
                          value={customerNameSearch}
                          onChange={(e) => {
                            setCustomerNameSearch(e.target.value);
                          }}
                          InputLabelProps={{ shrink: true }}
                        ></PText>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )
          : false}

        {searchFilter.id === 6
          ? true && (
              <Grid item xs={2}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>
                        <PSelect
                          label={translate("Terminal")}
                          placeholder={translate("Select...")}
                          options={props.terminalOptions}
                          value={selectedTerminal}
                          onChange={(event, newValue) => {
                            setSelectedTerminal(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )
          : false}

        {props.saleType == "SALE_ORDER"
          ? true && (
              <Grid item xs={2}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>
                        <PSelect
                          label={translate("Status")}
                          placeholder={translate("Select...")}
                          options={[
                            { name: "Created", id: "CREATED" },
                            { name: "Closed", id: "CLOSED" },
                            { name: "Cancelled", id: "CANCELLED" },
                          ]}
                          value={selectedStatus}
                          onChange={(event, newValue) => {
                            setSelectedStatus(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )
          : false}

        {props.saleType == "SERVICE"
          ? true && (
              <Grid item xs={2}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>
                        <PSelect
                          style={{
                            width: "100%",
                          }}
                          label={translate("Status")}
                          placeholder={translate("Select...")}
                          options={props.statusOptions}
                          value={selectedStatus}
                          onChange={(event, newValue) => {
                            setSelectedStatus(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )
          : false}

        {props.saleType == "SERVICE"
          ? true && (
              <Grid item xs={2}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <PSelect
                          label={"Assigned"}
                          style={{
                            width: "100%",
                            marginBottom: "10px",
                          }}
                          options={props.userOptions}
                          value={selectedUser}
                          onChange={(event, newValue) => {
                            setSelectedUser(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )
          : false}

        <Grid item xs={2}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <PDatePicker
                    label="From"
                    value={startDate}
                    onChange={(value) => {
                      setStartDate(value);
                    }}
                  ></PDatePicker>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={2}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td>
                  <PDatePicker
                    label="To"
                    value={endDate}
                    onChange={(value) => {
                      setEndDate(value);
                    }}
                  ></PDatePicker>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={2}>
          <Button
            //fullWidth={true}
            variant="contained"
            color="primary"
            //disabled={!enableGenerate}
            onClick={onSearch}
          >
            Search
          </Button>
        </Grid>
      </Grid>

      <ThemeProvider theme={theme}>
        <MUIDataTable
          data={saleHistoryData}
          columns={
            props.context.appMode === "desktop-pos"
              ? getDesktopColumns()
              : mobileColumns
          }
          options={option}
        />
      </ThemeProvider>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      <PFileViewer
        openWindow={openFileViewWindow}
        setOpenWindow={setOpenFileViewWindow}
        showMessage={props.showMessage}
        filesList={previewFileList}
        setAlert={props.setAlert}
        disableDefaultPrint={true}
      ></PFileViewer>
      {showServiceUpdateWindow && (
        <ServiceUpdate
          setShowServiceUpdateWindow={setShowServiceUpdateWindow}
          context={props.context}
          serviceBean={serviceBean}
          setServiceBean={setServiceBean}
          userOptions={props.userOptions}
          srAssigneeLabel={props.srAssigneeLabel}
          statusOptions={props.statusOptions}
          handleHistorySearch={onSearch}
          showMessage={props.showMessage}
        ></ServiceUpdate>
      )}
    </div>
  );
}
